import React from "react";
import { forwardRef } from "react";
// material
import { IconButton, IconButtonProps } from "@mui/material";
//
import { ButtonAnimate } from "../animate";

interface Props extends IconButtonProps {
  children?: React.ReactNode;
}

const MIconButton = forwardRef<any, Props>(
  ({ children, ...other }: Props, ref) => (
    <ButtonAnimate>
      <IconButton ref={ref} {...other}>
        {children}
      </IconButton>
    </ButtonAnimate>
  )
);

export default MIconButton;
